import React, { useEffect } from "react";

const ViewportContainer = ({ children, className = "" }) => {
  useEffect(() => {
    const setVH = () => {
      // 실제 뷰포트 높이를 CSS 변수로 설정
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    // 초기 실행
    setVH();

    // 리사이즈 이벤트에 대응
    window.addEventListener("resize", setVH);

    // 방향 전환 이벤트에 대응 (모바일 기기)
    window.addEventListener("orientationchange", setVH);

    return () => {
      window.removeEventListener("resize", setVH);
      window.removeEventListener("orientationchange", setVH);
    };
  }, []);

  return (
    <div
      className={`w-full ${className}`}
      style={{
        height: "calc(var(--vh, 1vh) * 100)",
        // Safari에서 주소창이 보이거나 숨겨질 때 부드러운 전환
        transition: "height 0.3s ease",
      }}
    >
      {children}
    </div>
  );
};

export default ViewportContainer;
